// Canonical application version — single source of truth.
// Consumed by the admin sidebar and the public footer so version displays never drift.
export const APP_VERSION = "9.2.26.20";
